module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Düzeltici ve Önleyici Aksiyon Takibi","garantiTitle":"Uygunsuzluk ve Aksiyon Planı","openedCount":"Açık Madde","totalCount":"Toplam Madde","lastUpdatingTime":"Son Güncelleme Tarihi"},"en":{"title":"Corrective and Preventive Action Tracking","garantiTitle":"Corrective and Preventive Action Tracking","openedCount":"Open Items","totalCount":"Total Items","lastUpdatingTime":"Last Update"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Audit/Audits/Audit.vue
// module id = vvkX
// module chunks = 1